import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=f8fa9fa4&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8fa9fa4')) {
      api.createRecord('f8fa9fa4', component.options)
    } else {
      api.reload('f8fa9fa4', component.options)
    }
    module.hot.accept("./Unauthorized.vue?vue&type=template&id=f8fa9fa4&", function () {
      api.rerender('f8fa9fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Unauthorized.vue"
export default component.exports